module.exports = __webpack_public_path__ + "img/PhirePhox.876d8ad0.png";